import React from 'react'
import AuthComponent from '../../components/AuthComponent/AuthComponent'

const Auth = () => {
  return (
    <AuthComponent  />

  )
}

export default Auth